import { useAppSelector } from '@shared/store';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountUserRegistrationSource = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectUserRegistrationSource);
};
